import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { ReservationService } from '../../../services/reservation.service';
import { ReservationHisRequest } from '../../../model/reservation-his-request';

@Component({
  selector: 'app-reservation-his-request-dialog',
  templateUrl: './reservartion-his-request-dialog.component.html',
  styleUrls: ['./reservartion-his-request-dialog.component.css']
})
export class ReservationHisRequestDialogComponent implements OnInit {

  loading: boolean;
  request: ReservationHisRequest;

  constructor(
    private reservationService: ReservationService,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<ReservationHisRequestDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: number) { }
 
  onNoClick(): void {
    this.dialogRef.close(false);
  }
 

  async ngOnInit() {
    try {
      this.loading = true; 
      this.request = await this.reservationService.getReservationHisRequest(this.data); 
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Solicitud HIS');
    } finally {
      this.loading = false;
    }
  }
}
